import memoize from 'memoize-one';
import plans from '@mssgme/plans';

export const getPlans = () => {
    return Object.values(plans);
};

const getId = (plan) => plan.id;
const isPaid = (plan) => plan.paddle || plan.liqpay;
const isUnpaid = (plan) => !plan.paddle && !plan.liqpay;
const isDeprecated = (plan) => plan.deprecated;
const isPublished = (plan) => plan.published;

export const getPlanTypes = memoize(() => {
    const plans = getPlans();
    const paid = plans.filter(isPaid).map(getId);
    const unpaid = ['unlimited', ...plans.filter(isUnpaid).map(getId)];
    const deprecated = plans.filter(isDeprecated).map(getId);
    const actual = plans.filter(isPublished).map(getId);
    const upgradeable = ['basic', ...actual];

    return {
        BASIC: 'basic',
        UNLIMITED: 'unlimited',
        UNPAID: unpaid,
        PAID: paid,
        UPGRADEABLE: upgradeable,
        DEPRECATED: deprecated,
        ACTUAL: actual,
    };
});

export const getPlanIds = () => {
    return getPlans().map((plan) => plan.id);
};

export const getPlanDefinition = (plan) => {
    return plan && getPlans().find((definition) => definition.id === plan);
};

export const getPlanAllowedQuantity = (plan, quantity) => {
    const definition = getPlanDefinition(plan);
    const fixed = definition.fixedQuantity;

    if (fixed) {
        if (Array.isArray(fixed)) {
            const [min, max] = fixed.map(Number);

            return Math.max(min, Math.min(quantity || 1, max));
        }

        return +fixed;
    }

    return quantity;
};
